import React, { useState } from 'react';
import Div from '../Div';

export default function VideoModal({ bgUrl, variant }) {
  const [toggle, setToggle] = useState(false);

  const handleClick = () => {
    setToggle(true);
  };

  const handleClose = () => {
    setToggle(false);
  };

  return (
    <>
      {/* 
        This clickable background image triggers the modal 
      */}
      <Div
        className={`cs-video_block ${variant ? variant : 'cs-style1'} cs-bg`}
        style={{ backgroundImage: `url(${bgUrl})` }}
        onClick={handleClick}
      >
        <span className="cs-player_btn cs-accent_color">
          <span />
        </span>
      </Div>

      {/* 
        Modal (popup) 
      */}
      <Div className={toggle ? 'cs-video_popup active' : 'cs-video_popup'}>
        <Div className="cs-video_popup_overlay" />
        <Div className="cs-video_popup_content">
          <Div className="cs-video_popup_layer" />
          <Div className="cs-video_popup_container">
            <Div className="cs-video_popup_align">
              <Div className="embed-responsive embed-responsive-16by9">
                {/* 
                  Our local video, served from the public folder
                */}
                {toggle && (
                  <video
                    className="embed-responsive-item"
                    src="/images/videobanner.mp4"
                    controls
                    autoPlay
                  />
                )}
              </Div>
            </Div>
            <Div className="cs-video_popup_close" onClick={handleClose} />
          </Div>
        </Div>
      </Div>
    </>
  );
}
